export enum SettingsTabEnum {
  ORGANISATION = 'organisation',
  NOTIFICATIONS = 'notifications',
  SELLER = 'seller',
  FEATURES = 'features'
}

export type SettingsTab = {
  value: SettingsTabEnum;
  label: string;
};

export const SETTINGS_TABS: SettingsTab[] = [
  { value: SettingsTabEnum.ORGANISATION, label: 'Organisation' },
  { value: SettingsTabEnum.NOTIFICATIONS, label: 'Notifications' },
  { value: SettingsTabEnum.SELLER, label: 'Seller inspection interface' },
  { value: SettingsTabEnum.FEATURES, label: 'Features' }
];

export const isSettingsTab = (
  value?: string | null
): value is SettingsTabEnum => SETTINGS_TABS.some((tab) => tab.value === value);

export const getSettingsTabIndex = (tab: SettingsTabEnum): number =>
  SETTINGS_TABS.findIndex((item) => item.value === tab);

export const SETTINGS_TAB_BY_FIELD: Record<string, SettingsTabEnum> = {
  notificationEmail: SettingsTabEnum.NOTIFICATIONS,
  brokerEmails: SettingsTabEnum.NOTIFICATIONS,
  supportEnquiryEmail: SettingsTabEnum.NOTIFICATIONS,
  primaryColour: SettingsTabEnum.SELLER,
  logo: SettingsTabEnum.SELLER
};

export const getSettingsTabForField = (field: string): SettingsTabEnum =>
  SETTINGS_TAB_BY_FIELD[field] || SettingsTabEnum.ORGANISATION;
